import { useState } from 'react'

import Input from 'common/components/input'
import useDebounce from 'common/hooks/useDebounce'

const MIN_SEARCH_LENGTH = 3

const SearchInput = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState('')

  const debouncedSearch = useDebounce(onSearch, 500)

  const handleChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
    if (value === '') {
      debouncedSearch('')
      return
    }
    if (value.length < MIN_SEARCH_LENGTH) {
      return
    }
    debouncedSearch(value)
  }

  return (
    <Input
      type="search"
      className="w-60"
      placeholder="Find content"
      data-testid="content-search"
      aria-label="content search"
      value={searchValue}
      onChange={handleChange}
    />
  )
}

export default SearchInput
